var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('CrmToolbar', [_c('div', {
    staticClass: "crm-funnel-toolbar"
  }, [_c('div', {
    staticClass: "crm-funnel-selector"
  }, [_c('label', {
    attrs: {
      "for": "crm-funnel-select"
    }
  }, [_vm._v("Funil")]), _c('b-form-select', {
    attrs: {
      "id": "crm-funnel-select",
      "options": _vm.funilOptionsSemTodos,
      "value": _vm.funilAtualId
    },
    on: {
      "change": _vm.selecionarFunilRapido
    }
  })], 1), _c('div', {
    staticClass: "crm-quick-search"
  }, [_c('label', {
    attrs: {
      "for": "crm-funnel-quick-search"
    }
  }, [_vm._v("Busca rápida")]), _c('div', {
    staticClass: "crm-quick-search-input"
  }, [_c('i', {
    staticClass: "la la-search"
  }), _c('b-form-input', {
    attrs: {
      "id": "crm-funnel-quick-search",
      "placeholder": "Nome ou título do card",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.debouncedLoadKanban
    },
    model: {
      value: _vm.filtros.busca,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "busca", $$v);
      },
      expression: "filtros.busca"
    }
  }), _vm.filtros.busca ? _c('button', {
    staticClass: "crm-quick-search-clear",
    attrs: {
      "type": "button",
      "title": "Limpar busca"
    },
    on: {
      "click": _vm.limparBuscaRapida
    }
  }, [_c('i', {
    staticClass: "la la-times"
  })]) : _vm._e()], 1)]), _c('div', {
    staticClass: "crm-filter-bar"
  }, [_c('button', {
    staticClass: "btn btn-light-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.filtersDrawerVisible = true;
      }
    }
  }, [_c('i', {
    staticClass: "la la-filter"
  }), _vm._v(" Filtros "), _vm.activeFilterCount ? _c('span', {
    staticClass: "crm-filter-count"
  }, [_vm._v(" " + _vm._s(_vm.activeFilterCount) + " ")]) : _vm._e()]), _c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadKanban
    }
  }, [_vm._v(" Atualizar ")]), _vm.activeFilterCount ? _c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.limparFiltros
    }
  }, [_vm._v(" Limpar filtros ")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-dark btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.abrirModalCriacao();
      }
    }
  }, [_vm._v(" Nova oportunidade ")])])])]), _c('CrmActiveFilters', {
    attrs: {
      "filters": _vm.activeFilters
    },
    on: {
      "remove": _vm.limparFiltroAtivo
    }
  }), _c('b-sidebar', {
    attrs: {
      "backdrop": "",
      "right": "",
      "shadow": "",
      "title": "Filtros do funil",
      "width": "420px"
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "crm-drawer-footer"
        }, [_c('button', {
          staticClass: "btn btn-light",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.limparFiltros
          }
        }, [_vm._v(" Limpar ")]), _c('button', {
          staticClass: "btn btn-dark",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.aplicarFiltros
          }
        }, [_vm._v(" Aplicar filtros ")])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.filtersDrawerVisible,
      callback: function callback($$v) {
        _vm.filtersDrawerVisible = $$v;
      },
      expression: "filtersDrawerVisible"
    }
  }, [_c('div', {
    staticClass: "crm-filter-drawer"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Funil"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.funilOptions
    },
    model: {
      value: _vm.filtros.id_crm_funil,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "id_crm_funil", $$v);
      },
      expression: "filtros.id_crm_funil"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Responsável"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.usuarioOptions
    },
    model: {
      value: _vm.filtros.id_usuario,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "id_usuario", $$v);
      },
      expression: "filtros.id_usuario"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Status"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.statusOptions
    },
    model: {
      value: _vm.filtros.status,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "status", $$v);
      },
      expression: "filtros.status"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Fonte do lead"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.fonteFiltroOptions
    },
    model: {
      value: _vm.filtros.id_crm_fonte,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "id_crm_fonte", $$v);
      },
      expression: "filtros.id_crm_fonte"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Temperatura"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.temperaturaFiltroOptions
    },
    model: {
      value: _vm.filtros.temperatura,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "temperatura", $$v);
      },
      expression: "filtros.temperatura"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Busca geral"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Cliente, contato ou título"
    },
    on: {
      "input": _vm.debouncedLoadKanban
    },
    model: {
      value: _vm.filtros.busca,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "busca", $$v);
      },
      expression: "filtros.busca"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Busca em notas"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Palavra nas notas ou timeline"
    },
    model: {
      value: _vm.filtros.busca_notas,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "busca_notas", $$v);
      },
      expression: "filtros.busca_notas"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Próxima tarefa"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.periodoAtividadeOptions
    },
    model: {
      value: _vm.filtros.periodo_atividade,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "periodo_atividade", $$v);
      },
      expression: "filtros.periodo_atividade"
    }
  })], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data inicial"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.filtros.data_inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "data_inicio", $$v);
      },
      expression: "filtros.data_inicio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data final"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.filtros.data_fim,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "data_fim", $$v);
      },
      expression: "filtros.data_fim"
    }
  })], 1)], 1)], 1)], 1)]), _vm.loading ? _c('CrmEmptyState', {
    attrs: {
      "title": "Carregando funil...",
      "description": "Buscando oportunidades, valores e próximas ações.",
      "icon": "la la-refresh"
    }
  }) : _vm.kanbanError ? _c('CrmEmptyState', {
    attrs: {
      "title": "Acesso indisponível",
      "description": _vm.kanbanError,
      "icon": "la la-lock"
    }
  }) : _vm.kanban ? _c('div', {
    staticClass: "crm-kanban-shell"
  }, [_c('div', {
    ref: "kanbanTopScroll",
    staticClass: "crm-kanban-top-scroll",
    on: {
      "scroll": function scroll($event) {
        return _vm.sincronizarKanbanScroll('top');
      }
    }
  }, [_c('div', {
    staticClass: "crm-kanban-scroll-content",
    style: {
      width: "".concat(_vm.kanbanScrollWidth, "px")
    }
  })]), _c('div', {
    ref: "kanbanScroll",
    staticClass: "crm-kanban",
    on: {
      "scroll": function scroll($event) {
        return _vm.sincronizarKanbanScroll('bottom');
      }
    }
  }, _vm._l(_vm.kanban.colunas, function (coluna) {
    return _c('div', {
      key: coluna.etapa.id_crm_etapa,
      staticClass: "crm-kanban-column",
      class: {
        'is-drop-target': _vm.colunaDropAtiva(coluna),
        'is-drop-source': _vm.colunaDragOrigem(coluna),
        'is-moving': _vm.dragState.moving
      },
      on: {
        "dragenter": function dragenter($event) {
          $event.preventDefault();
          return _vm.marcarColunaDrop(coluna);
        },
        "dragleave": function dragleave($event) {
          return _vm.limparColunaDrop(coluna, $event);
        },
        "dragover": function dragover($event) {
          $event.preventDefault();
          return _vm.marcarColunaDrop(coluna);
        },
        "drop": function drop($event) {
          $event.preventDefault();
          return _vm.soltarOportunidade(coluna);
        }
      }
    }, [_c('div', {
      staticClass: "crm-kanban-header"
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(coluna.etapa.nome))]), coluna.valor_total !== null ? _c('div', {
      staticClass: "crm-kanban-value"
    }, [_vm._v(" " + _vm._s(_vm.formatMoney(coluna.valor_total)) + " ")]) : _vm._e(), _vm.etapaAutomacaoResumo(coluna.etapa) ? _c('small', {
      staticClass: "crm-stage-automation"
    }, [_vm._v(" " + _vm._s(_vm.etapaAutomacaoResumo(coluna.etapa)) + " ")]) : _vm._e()]), _c('span', {
      staticClass: "label label-inline label-light-primary"
    }, [_vm._v(_vm._s(coluna.total))])]), _vm.colunaDropAtiva(coluna) ? _c('div', {
      staticClass: "crm-drop-hint"
    }, [_vm._v(" Solte para mover para " + _vm._s(coluna.etapa.nome) + " ")]) : _vm._e(), _vm._l(coluna.oportunidades, function (oportunidade) {
      return _c('CrmDealCard', {
        key: oportunidade.id_crm_oportunidade,
        attrs: {
          "dragging": _vm.oportunidadeEmDrag(oportunidade),
          "draggable": oportunidade.status === 'aberta' && !_vm.dragState.moving,
          "oportunidade": oportunidade,
          "temperature-options": _vm.temperaturaOptions
        },
        on: {
          "drag-end": _vm.encerrarDrag,
          "drag-start": _vm.iniciarDrag,
          "open": _vm.abrirDetalhe,
          "task": _vm.abrirModalTarefa,
          "schedule": _vm.abrirModalAgenda,
          "note": _vm.abrirModalNota,
          "more": _vm.abrirModalAcoes,
          "temperature": _vm.abrirModalTemperatura
        }
      });
    }), coluna.oportunidades.length === 0 ? _c('CrmEmptyState', {
      attrs: {
        "title": "Nenhuma oportunidade",
        "description": "Crie uma oportunidade pelo botão acima dos filtros ou mova cards do funil.",
        "icon": "la la-columns"
      }
    }) : _vm._e(), coluna.oportunidades.length < coluna.total ? _c('button', {
      staticClass: "btn btn-light btn-sm btn-block mt-3",
      attrs: {
        "type": "button",
        "disabled": _vm.loadingEtapas[coluna.etapa.id_crm_etapa]
      },
      on: {
        "click": function click($event) {
          return _vm.carregarMais(coluna);
        }
      }
    }, [_vm._v(" Carregar mais ")]) : _vm._e()], 2);
  }), 0)]) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "crm-funil-oportunidade-modal",
      "title": _vm.modalTitle,
      "hide-footer": "",
      "size": "xl"
    }
  }, [!_vm.form.id_crm_oportunidade ? _c('div', {
    staticClass: "crm-wizard"
  }, [_c('div', {
    staticClass: "crm-wizard-steps"
  }, _vm._l(_vm.wizardSteps, function (step, index) {
    return _c('button', {
      key: step.key,
      staticClass: "crm-wizard-step",
      class: {
        active: _vm.wizardStep === index,
        done: _vm.wizardStep > index
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.irParaWizardStep(index);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(index + 1))]), _c('strong', [_vm._v(_vm._s(step.label))])]);
  }), 0), _c('div', {
    staticClass: "crm-wizard-body"
  }, [_c('section', {
    staticClass: "crm-wizard-main"
  }, [_vm.wizardStep === 0 ? _c('div', [_c('h3', [_vm._v("Nome da negociação")]), _c('p', [_vm._v("Use um nome curto e fácil de reconhecer no funil.")]), _c('b-form-group', {
    attrs: {
      "label": "Título da oportunidade"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autofocus": "",
      "maxlength": "140",
      "placeholder": "Ex.: Venda balcão - Maria Silva"
    },
    model: {
      value: _vm.form.titulo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "titulo", $$v);
      },
      expression: "form.titulo"
    }
  })], 1)], 1) : _vm.wizardStep === 1 ? _c('div', [_c('h3', [_vm._v("Cliente ou contato")]), _c('p', [_vm._v(" Busque um cadastro existente ou crie um contato rápido com WhatsApp. ")]), _c('BuscaClienteContato', {
    attrs: {
      "label": "Cliente ou contato"
    },
    on: {
      "criar-contato": _vm.criarContatoRapido
    },
    model: {
      value: _vm.vinculoSelecionado,
      callback: function callback($$v) {
        _vm.vinculoSelecionado = $$v;
      },
      expression: "vinculoSelecionado"
    }
  })], 1) : _vm.wizardStep === 2 ? _c('div', [_c('h3', [_vm._v("Dados comerciais")]), _c('p', [_vm._v(" Escolha o funil e informe os dados iniciais. A oportunidade entra na primeira etapa ativa. ")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Funil"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.funilOptionsSemTodos
    },
    on: {
      "change": function change($event) {
        _vm.form.id_crm_etapa = null;
      }
    },
    model: {
      value: _vm.form.id_crm_funil,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "id_crm_funil", $$v);
      },
      expression: "form.id_crm_funil"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "crm-stage-preview"
  }, [_c('span', [_vm._v("Etapa inicial")]), _c('strong', [_vm._v(_vm._s(_vm.etapaInicialLabel(_vm.form.id_crm_funil)))])])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor estimado"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.valor_estimado,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valor_estimado", $$v);
      },
      expression: "form.valor_estimado"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Responsável"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.usuarioOptionsSemTodos
    },
    model: {
      value: _vm.form.id_usuario,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "id_usuario", $$v);
      },
      expression: "form.id_usuario"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fonte do lead"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.fonteOptions
    },
    model: {
      value: _vm.form.id_crm_fonte,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "id_crm_fonte", $$v);
      },
      expression: "form.id_crm_fonte"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Campanha"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "120",
      "placeholder": "Ex.: Google Ads, indicação, feira"
    },
    model: {
      value: _vm.form.campanha,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "campanha", $$v);
      },
      expression: "form.campanha"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Previsão de fechamento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.form.previsao_fechamento,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "previsao_fechamento", $$v);
      },
      expression: "form.previsao_fechamento"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Próxima ação"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local"
    },
    model: {
      value: _vm.form.proxima_atividade_em,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "proxima_atividade_em", $$v);
      },
      expression: "form.proxima_atividade_em"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Temperatura/qualificação"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.temperaturaOptions
    },
    model: {
      value: _vm.form.temperatura,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "temperatura", $$v);
      },
      expression: "form.temperatura"
    }
  })], 1)], 1)], 1)], 1) : _c('div', [_c('h3', [_vm._v("Confirmar criação")]), _c('p', [_vm._v("Revise os principais dados antes de mandar para o funil.")]), _c('div', {
    staticClass: "crm-wizard-summary"
  }, [_c('div', [_c('span', [_vm._v("Negociação")]), _c('strong', [_vm._v(_vm._s(_vm.form.titulo || "Sem título"))])]), _c('div', [_c('span', [_vm._v("Cliente ou contato")]), _c('strong', [_vm._v(_vm._s(_vm.vinculoSelecionadoLabel))])]), _c('div', [_c('span', [_vm._v("Funil e etapa")]), _c('strong', [_vm._v(_vm._s(_vm.wizardFunilEtapaLabel))])]), _c('div', [_c('span', [_vm._v("Valor")]), _c('strong', [_vm._v(_vm._s(_vm.formatMoney(_vm.form.valor_estimado)))])]), _c('div', [_c('span', [_vm._v("Origem")]), _c('strong', [_vm._v(_vm._s(_vm.wizardOrigemLabel))])])])])]), _c('aside', {
    staticClass: "crm-wizard-preview"
  }, [_c('small', [_vm._v("Preview no funil")]), _c('CrmDealCard', {
    attrs: {
      "draggable": false,
      "oportunidade": _vm.wizardPreviewOportunidade,
      "show-actions": false,
      "temperature-options": _vm.temperaturaOptions
    },
    on: {
      "more": function more() {
        return null;
      },
      "note": function note() {
        return null;
      },
      "open": function open() {
        return null;
      },
      "schedule": function schedule() {
        return null;
      },
      "task": function task() {
        return null;
      }
    }
  })], 1)]), _c('div', {
    staticClass: "crm-wizard-footer"
  }, [_c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fecharCriacaoMaisTarde
    }
  }, [_vm._v(" Criar mais tarde ")]), _c('div', [_vm.wizardStep > 0 ? _c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.wizardStep -= 1;
      }
    }
  }, [_vm._v(" Voltar ")]) : _vm._e(), _vm.wizardStep < _vm.wizardSteps.length - 1 ? _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.avancarWizard
    }
  }, [_vm._v(" Próximo ")]) : _c('button', {
    staticClass: "btn btn-light-primary mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.savingOportunidade
    },
    on: {
      "click": function click($event) {
        return _vm.salvarOportunidade(true);
      }
    }
  }, [_vm._v(" Salvar e criar outra ")]), _vm.wizardStep === _vm.wizardSteps.length - 1 ? _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "button",
      "disabled": _vm.savingOportunidade
    },
    on: {
      "click": function click($event) {
        return _vm.salvarOportunidade(false);
      }
    }
  }, [_vm._v(" Criar oportunidade ")]) : _vm._e()])])]) : _c('div', [_c('b-form-group', {
    attrs: {
      "label": "Título"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "140"
    },
    model: {
      value: _vm.form.titulo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "titulo", $$v);
      },
      expression: "form.titulo"
    }
  })], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Funil"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.funilOptionsSemTodos
    },
    on: {
      "change": function change($event) {
        _vm.form.id_crm_etapa = null;
      }
    },
    model: {
      value: _vm.form.id_crm_funil,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "id_crm_funil", $$v);
      },
      expression: "form.id_crm_funil"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Etapa"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.etapaOptions(_vm.form.id_crm_funil)
    },
    model: {
      value: _vm.form.id_crm_etapa,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "id_crm_etapa", $$v);
      },
      expression: "form.id_crm_etapa"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor estimado"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.valor_estimado,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valor_estimado", $$v);
      },
      expression: "form.valor_estimado"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Responsável"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.usuarioOptionsSemTodos
    },
    model: {
      value: _vm.form.id_usuario,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "id_usuario", $$v);
      },
      expression: "form.id_usuario"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Previsão de fechamento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.form.previsao_fechamento,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "previsao_fechamento", $$v);
      },
      expression: "form.previsao_fechamento"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Próxima ação"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local"
    },
    model: {
      value: _vm.form.proxima_atividade_em,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "proxima_atividade_em", $$v);
      },
      expression: "form.proxima_atividade_em"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fonte do lead"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.fonteOptions
    },
    model: {
      value: _vm.form.id_crm_fonte,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "id_crm_fonte", $$v);
      },
      expression: "form.id_crm_fonte"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Campanha"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "120",
      "placeholder": "Ex.: Google Ads, indicação, feira"
    },
    model: {
      value: _vm.form.campanha,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "campanha", $$v);
      },
      expression: "form.campanha"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('crm-funil-oportunidade-modal');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "button",
      "disabled": _vm.savingOportunidade
    },
    on: {
      "click": function click($event) {
        return _vm.salvarOportunidade(false);
      }
    }
  }, [_vm._v(" Salvar ")])])], 1)]), _c('b-modal', {
    attrs: {
      "id": "crm-mover-oportunidade-modal",
      "title": "Mover oportunidade"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.moverOportunidade.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Etapa de destino"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.etapaOptions(_vm.oportunidadeSelecionada.id_crm_funil)
    },
    on: {
      "change": _vm.prepararCamposMovimento
    },
    model: {
      value: _vm.idEtapaDestino,
      callback: function callback($$v) {
        _vm.idEtapaDestino = $$v;
      },
      expression: "idEtapaDestino"
    }
  })], 1), _vm.movimentoExigeTecnico ? _c('b-form-group', {
    attrs: {
      "label": "Desenvolvedor da apresentação"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.desenvolvedorResponsavelOptions
    },
    model: {
      value: _vm.idUsuarioTecnicoDestino,
      callback: function callback($$v) {
        _vm.idUsuarioTecnicoDestino = $$v;
      },
      expression: "idUsuarioTecnicoDestino"
    }
  }), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Este desenvolvedor assume a apresentação técnica e a implementação White Label. ")])], 1) : _vm._e(), _vm.movimentoExigeAtribuicao ? _c('b-form-group', {
    attrs: {
      "label": "Vendedor responsável"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.vendedorResponsavelOptions
    },
    model: {
      value: _vm.idUsuarioDestino,
      callback: function callback($$v) {
        _vm.idUsuarioDestino = $$v;
      },
      expression: "idUsuarioDestino"
    }
  }), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Este vendedor ficará vinculado ao card durante todo o fluxo comercial. ")]), _vm.usuarioDestinoSemAcesso ? _c('b-form-checkbox', {
    staticClass: "mt-3",
    model: {
      value: _vm.concederAcessoFunilDestino,
      callback: function callback($$v) {
        _vm.concederAcessoFunilDestino = $$v;
      },
      expression: "concederAcessoFunilDestino"
    }
  }, [_vm._v(" Conceder acesso deste usuário ao funil atual ")]) : _vm._e()], 1) : _vm._e(), _vm.camposObrigatoriosMovimento.length ? _c('div', {
    staticClass: "crm-move-requirements"
  }, [_c('b-alert', {
    staticClass: "mb-4",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v(" Esta etapa exige informações antes de receber a oportunidade. ")]), _vm.movimentoExigeValorNegociacao ? _c('b-form-group', {
    attrs: {
      "label": "Valor negociado"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        value: true,
        text: 'Manter o valor já informado'
      }, {
        value: false,
        text: 'Informar novo valor'
      }],
      "stacked": ""
    },
    on: {
      "change": _vm.prepararCamposMovimento
    },
    model: {
      value: _vm.movimentoManterValor,
      callback: function callback($$v) {
        _vm.movimentoManterValor = $$v;
      },
      expression: "movimentoManterValor"
    }
  })], 1) : _vm._e(), _vm._l(_vm.camposObrigatoriosMovimento, function (regra) {
    return _c('b-form-group', {
      key: regra.id_crm_etapa_campo_obrigatorio,
      attrs: {
        "label": _vm.labelCampoObrigatorio(regra)
      }
    }, [_vm.campoObrigatorioTipo(regra) === 'lista' ? _c('b-form-select', {
      attrs: {
        "options": _vm.campoObrigatorioOptions(regra)
      },
      model: {
        value: _vm.movimentoCamposForm[regra.id_crm_campo_comercial],
        callback: function callback($$v) {
          _vm.$set(_vm.movimentoCamposForm, regra.id_crm_campo_comercial, $$v);
        },
        expression: "movimentoCamposForm[regra.id_crm_campo_comercial]"
      }
    }) : _vm.campoObrigatorioTipo(regra) === 'texto_longo' ? _c('b-form-textarea', {
      attrs: {
        "rows": "3"
      },
      model: {
        value: _vm.movimentoCamposForm[regra.id_crm_campo_comercial],
        callback: function callback($$v) {
          _vm.$set(_vm.movimentoCamposForm, regra.id_crm_campo_comercial, $$v);
        },
        expression: "movimentoCamposForm[regra.id_crm_campo_comercial]"
      }
    }) : _vm.campoObrigatorioTipo(regra) === 'numero' && _vm.isCampoObrigatorioMonetario(regra) ? _c('money', _vm._b({
      staticClass: "form-control",
      attrs: {
        "disabled": _vm.movimentoManterValor && _vm.campoObrigatorioChave(regra) === 'valor_negociacao'
      },
      model: {
        value: _vm.movimentoCamposForm[regra.id_crm_campo_comercial],
        callback: function callback($$v) {
          _vm.$set(_vm.movimentoCamposForm, regra.id_crm_campo_comercial, $$v);
        },
        expression: "movimentoCamposForm[regra.id_crm_campo_comercial]"
      }
    }, 'money', _vm.priceOptions, false)) : _vm.campoObrigatorioTipo(regra) === 'numero' ? _c('b-form-input', {
      attrs: {
        "type": "number",
        "step": "0.01",
        "disabled": _vm.movimentoManterValor && _vm.campoObrigatorioChave(regra) === 'valor_negociacao'
      },
      model: {
        value: _vm.movimentoCamposForm[regra.id_crm_campo_comercial],
        callback: function callback($$v) {
          _vm.$set(_vm.movimentoCamposForm, regra.id_crm_campo_comercial, $$v);
        },
        expression: "movimentoCamposForm[regra.id_crm_campo_comercial]"
      }
    }) : _c('b-form-input', {
      model: {
        value: _vm.movimentoCamposForm[regra.id_crm_campo_comercial],
        callback: function callback($$v) {
          _vm.$set(_vm.movimentoCamposForm, regra.id_crm_campo_comercial, $$v);
        },
        expression: "movimentoCamposForm[regra.id_crm_campo_comercial]"
      }
    }), regra.mensagem ? _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" " + _vm._s(regra.mensagem) + " ")]) : _vm._e()], 1);
  })], 2) : _vm._e()], 1), _c('b-modal', {
    attrs: {
      "id": "crm-funil-temperatura-modal",
      "title": "Temperatura da oportunidade"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.salvarTemperaturaOportunidade.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Oportunidade"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.oportunidadeSelecionada.titulo,
      "disabled": ""
    }
  })], 1), _c('div', {
    staticClass: "crm-temperature-grid"
  }, _vm._l(_vm.temperaturaOptions, function (option) {
    return _c('button', {
      key: String(option.value),
      staticClass: "crm-temperature-option",
      class: {
        active: _vm.temperaturaForm.temperatura === option.value
      },
      style: {
        '--temperature-color': _vm.temperaturaColor(option.value)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          _vm.temperaturaForm.temperatura = option.value;
        }
      }
    }, [_c('i', {
      class: _vm.temperaturaIcon(option.value)
    }), _c('span', [_vm._v(_vm._s(option.text))])]);
  }), 0)], 1), _c('b-modal', {
    attrs: {
      "id": "crm-funil-acoes-modal",
      "title": "Ações da oportunidade",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "crm-actions-modal"
  }, [_c('button', {
    staticClass: "btn btn-light btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.abrirDetalhe(_vm.oportunidadeSelecionada);
      }
    }
  }, [_vm._v(" Abrir detalhe ")]), _c('button', {
    staticClass: "btn btn-light btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.abrirModalEdicao(_vm.oportunidadeSelecionada);
      }
    }
  }, [_vm._v(" Editar oportunidade ")]), _c('button', {
    staticClass: "btn btn-light-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.abrirModalMover(_vm.oportunidadeSelecionada);
      }
    }
  }, [_vm._v(" Mover etapa ")]), _vm.isContrato(_vm.oportunidadeSelecionada) ? _c('button', {
    staticClass: "btn btn-light-info btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.abrirDadosNegociacao(_vm.oportunidadeSelecionada);
      }
    }
  }, [_vm._v(" Visualizar dados da negociação ")]) : _vm._e(), _vm.isContrato(_vm.oportunidadeSelecionada) ? _c('button', {
    staticClass: "btn btn-light-success btn-block",
    attrs: {
      "type": "button",
      "disabled": !_vm.telefoneContrato(_vm.oportunidadeSelecionada)
    },
    on: {
      "click": function click($event) {
        return _vm.enviarContratoWhatsapp(_vm.oportunidadeSelecionada);
      }
    }
  }, [_vm._v(" Enviar contrato por WhatsApp ")]) : _vm._e(), _vm.isContrato(_vm.oportunidadeSelecionada) ? _c('button', {
    staticClass: "btn btn-light-primary btn-block",
    attrs: {
      "type": "button",
      "disabled": !_vm.emailContrato(_vm.oportunidadeSelecionada)
    },
    on: {
      "click": function click($event) {
        return _vm.enviarContratoEmail(_vm.oportunidadeSelecionada);
      }
    }
  }, [_vm._v(" Enviar contrato por e-mail ")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-light-success btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.abrirModalGanho(_vm.oportunidadeSelecionada);
      }
    }
  }, [_vm._v(" Marcar como ganha ")]), _c('button', {
    staticClass: "btn btn-light-danger btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.abrirModalPerda(_vm.oportunidadeSelecionada);
      }
    }
  }, [_vm._v(" Marcar como perdida ")])])]), _c('b-modal', {
    attrs: {
      "id": "crm-perder-oportunidade-modal",
      "title": "Marcar como perdida"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.marcarPerdida.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Motivo da perda"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.motivoPerdaOptions
    },
    model: {
      value: _vm.perda.id_crm_motivo_perda,
      callback: function callback($$v) {
        _vm.$set(_vm.perda, "id_crm_motivo_perda", $$v);
      },
      expression: "perda.id_crm_motivo_perda"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Observação"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3"
    },
    model: {
      value: _vm.perda.motivo_perda_observacao,
      callback: function callback($$v) {
        _vm.$set(_vm.perda, "motivo_perda_observacao", $$v);
      },
      expression: "perda.motivo_perda_observacao"
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "crm-ganhar-oportunidade-modal",
      "title": "Fechar oportunidade",
      "cancel-title": "Cancelar",
      "ok-title": "Confirmar",
      "size": "xl"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.marcarGanha.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "crm-close-summary"
  }, [_c('strong', [_vm._v(_vm._s(_vm.ganho.titulo))]), _c('span', [_vm._v(_vm._s(_vm.ganho.cliente))])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome correto"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "120"
    },
    model: {
      value: _vm.ganho.nome_correto,
      callback: function callback($$v) {
        _vm.$set(_vm.ganho, "nome_correto", $$v);
      },
      expression: "ganho.nome_correto"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CNPJ"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "maxlength": "18"
    },
    model: {
      value: _vm.ganho.cnpj,
      callback: function callback($$v) {
        _vm.$set(_vm.ganho, "cnpj", $$v);
      },
      expression: "ganho.cnpj"
    }
  }), _c('b-input-group-append', [_c('button', {
    staticClass: "btn btn-light-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.loadingConsultaCnpjFechamento
    },
    on: {
      "click": _vm.consultarCnpjFechamento
    }
  }, [_c('i', {
    staticClass: "la la-search"
  }), _vm._v(" Consultar ")])])], 1)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "E-mail"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email",
      "maxlength": "120"
    },
    model: {
      value: _vm.ganho.email_cliente,
      callback: function callback($$v) {
        _vm.$set(_vm.ganho, "email_cliente", $$v);
      },
      expression: "ganho.email_cliente"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Telefone"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "20"
    },
    model: {
      value: _vm.ganho.telefone_cliente,
      callback: function callback($$v) {
        _vm.$set(_vm.ganho, "telefone_cliente", $$v);
      },
      expression: "ganho.telefone_cliente"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "crm-close-address"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CEP"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "maxlength": "9"
    },
    model: {
      value: _vm.ganho.cep,
      callback: function callback($$v) {
        _vm.$set(_vm.ganho, "cep", $$v);
      },
      expression: "ganho.cep"
    }
  }), _c('b-input-group-append', [_c('button', {
    staticClass: "btn btn-light-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.loadingConsultaCepFechamento
    },
    on: {
      "click": _vm.consultarCepFechamento
    }
  }, [_c('i', {
    staticClass: "la la-search"
  }), _vm._v(" Consultar ")])])], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cidade"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.cidadeFechamentoLabel,
      "disabled": ""
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Logradouro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "100"
    },
    model: {
      value: _vm.ganho.logradouro,
      callback: function callback($$v) {
        _vm.$set(_vm.ganho, "logradouro", $$v);
      },
      expression: "ganho.logradouro"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Número"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "30"
    },
    model: {
      value: _vm.ganho.numero,
      callback: function callback($$v) {
        _vm.$set(_vm.ganho, "numero", $$v);
      },
      expression: "ganho.numero"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Bairro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "100"
    },
    model: {
      value: _vm.ganho.bairro,
      callback: function callback($$v) {
        _vm.$set(_vm.ganho, "bairro", $$v);
      },
      expression: "ganho.bairro"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Complemento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "100"
    },
    model: {
      value: _vm.ganho.complemento,
      callback: function callback($$v) {
        _vm.$set(_vm.ganho, "complemento", $$v);
      },
      expression: "ganho.complemento"
    }
  })], 1)], 1)], 1), _c('b-form-group', {
    attrs: {
      "label": "Endereço completo"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "255"
    },
    model: {
      value: _vm.ganho.endereco_cliente,
      callback: function callback($$v) {
        _vm.$set(_vm.ganho, "endereco_cliente", $$v);
      },
      expression: "ganho.endereco_cliente"
    }
  })], 1)], 1), _c('b-form-group', {
    attrs: {
      "label": "Valor final"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.ganho.valor_final,
      callback: function callback($$v) {
        _vm.$set(_vm.ganho, "valor_final", $$v);
      },
      expression: "ganho.valor_final"
    }
  }, 'money', _vm.priceOptions, false))], 1), _c('b-form-group', {
    attrs: {
      "label": "Benefícios digitáveis"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3",
      "max-rows": "5",
      "placeholder": "Digite descontos, parcelamentos, bônus ou observações combinadas."
    },
    model: {
      value: _vm.ganho.beneficios_livres,
      callback: function callback($$v) {
        _vm.$set(_vm.ganho, "beneficios_livres", $$v);
      },
      expression: "ganho.beneficios_livres"
    }
  })], 1), !_vm.ganho.cliente_final ? _c('b-form-group', {
    attrs: {
      "label": "Benefícios de regra"
    }
  }, [_c('div', {
    staticClass: "crm-benefit-suggestions"
  }, _vm._l(_vm.beneficioOptions, function (beneficio) {
    return _c('button', {
      key: beneficio.value,
      class: ['crm-benefit-chip', {
        active: _vm.beneficioEstruturadoSelecionado(beneficio.value)
      }],
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.toggleBeneficioGanho(beneficio.value);
        }
      }
    }, [_vm._v(" " + _vm._s(beneficio.text) + " ")]);
  }), 0)]) : _vm._e(), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Ao confirmar, o CRM salva os dados do cliente, registra os benefícios na oportunidade e cria a entrada no funil Contratos. ")])], 1), _c('b-modal', {
    attrs: {
      "id": "crm-dados-negociacao-modal",
      "title": "Dados da negociação",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "crm-negotiation-data"
  }, [_c('div', [_c('span', [_vm._v("Cliente")]), _c('strong', [_vm._v(_vm._s(_vm.dadosNegociacao.cliente))])]), _c('div', [_c('span', [_vm._v("Negociação original")]), _c('strong', [_vm._v(_vm._s(_vm.dadosNegociacao.origem))])]), _c('div', [_c('span', [_vm._v("Valor")]), _c('strong', [_vm._v(_vm._s(_vm.formatMoney(_vm.dadosNegociacao.valor)))])]), _c('div', [_c('span', [_vm._v("Telefone")]), _c('strong', [_vm._v(_vm._s(_vm.dadosNegociacao.telefone || "Não informado"))])]), _c('div', [_c('span', [_vm._v("E-mail")]), _c('strong', [_vm._v(_vm._s(_vm.dadosNegociacao.email || "Não informado"))])]), _c('div', [_c('span', [_vm._v("Benefícios concedidos")]), _c('strong', [_vm._v(_vm._s(_vm.dadosNegociacao.beneficios || "Não informado"))])])]), _c('div', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('crm-dados-negociacao-modal');
      }
    }
  }, [_vm._v(" Fechar ")])])]), _c('b-sidebar', {
    attrs: {
      "id": "crm-funil-tarefa-drawer",
      "title": "Criar tarefa",
      "backdrop": "",
      "right": "",
      "shadow": "",
      "width": "520px"
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "crm-drawer-footer"
        }, [_c('button', {
          staticClass: "btn btn-light",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.tarefaDrawerVisible = false;
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('button', {
          staticClass: "btn btn-light-primary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.criarTarefa(true);
            }
          }
        }, [_vm._v(" Salvar e agendar ")]), _c('button', {
          staticClass: "btn btn-dark",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.criarTarefa(false);
            }
          }
        }, [_vm._v(" Salvar tarefa ")])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.tarefaDrawerVisible,
      callback: function callback($$v) {
        _vm.tarefaDrawerVisible = $$v;
      },
      expression: "tarefaDrawerVisible"
    }
  }, [_c('div', {
    staticClass: "crm-drawer-body"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Oportunidade"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.oportunidadeSelecionada.titulo,
      "disabled": ""
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Título"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "140"
    },
    model: {
      value: _vm.tarefaForm.titulo,
      callback: function callback($$v) {
        _vm.$set(_vm.tarefaForm, "titulo", $$v);
      },
      expression: "tarefaForm.titulo"
    }
  })], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.tipoTarefaOptions
    },
    model: {
      value: _vm.tarefaForm.tipo,
      callback: function callback($$v) {
        _vm.$set(_vm.tarefaForm, "tipo", $$v);
      },
      expression: "tarefaForm.tipo"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Responsável"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.usuarioOptionsSemTodos
    },
    model: {
      value: _vm.tarefaForm.id_usuario,
      callback: function callback($$v) {
        _vm.$set(_vm.tarefaForm, "id_usuario", $$v);
      },
      expression: "tarefaForm.id_usuario"
    }
  })], 1)], 1)], 1), _c('b-form-group', {
    attrs: {
      "label": "Vencimento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local"
    },
    model: {
      value: _vm.tarefaForm.vencimento_em,
      callback: function callback($$v) {
        _vm.$set(_vm.tarefaForm, "vencimento_em", $$v);
      },
      expression: "tarefaForm.vencimento_em"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Descrição"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3"
    },
    model: {
      value: _vm.tarefaForm.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.tarefaForm, "descricao", $$v);
      },
      expression: "tarefaForm.descricao"
    }
  })], 1), _c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.tarefaForm.concluir_ao_criar,
      callback: function callback($$v) {
        _vm.$set(_vm.tarefaForm, "concluir_ao_criar", $$v);
      },
      expression: "tarefaForm.concluir_ao_criar"
    }
  }, [_vm._v(" Concluir ao criar ")])], 1)]), _c('b-sidebar', {
    attrs: {
      "id": "crm-funil-agenda-drawer",
      "title": _vm.agendaDrawerTitle,
      "backdrop": "",
      "right": "",
      "shadow": "",
      "width": "560px"
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "crm-drawer-footer"
        }, [_c('button', {
          staticClass: "btn btn-light",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.agendaDrawerVisible = false;
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('button', {
          staticClass: "btn btn-dark",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.criarAgenda
          }
        }, [_vm._v(" Salvar agendamento ")])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.agendaDrawerVisible,
      callback: function callback($$v) {
        _vm.agendaDrawerVisible = $$v;
      },
      expression: "agendaDrawerVisible"
    }
  }, [_c('div', {
    staticClass: "crm-drawer-body"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Oportunidade"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.oportunidadeSelecionada.titulo,
      "disabled": ""
    }
  })], 1), _vm.tarefaAgendamentoOrigem ? _c('div', {
    staticClass: "crm-agenda-cliente mb-4"
  }, [_c('span', [_vm._v("Tarefa vinculada")]), _c('strong', [_vm._v(_vm._s(_vm.tarefaAgendamentoOrigem.titulo))])]) : _vm._e(), _c('div', {
    staticClass: "crm-agenda-cliente mb-4"
  }, [_c('span', [_vm._v("Cliente ou contato")]), _c('strong', [_vm._v(_vm._s(_vm.agendaClienteLabel))])]), _c('b-form-group', {
    attrs: {
      "label": "Título"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "140"
    },
    model: {
      value: _vm.agendaForm.titulo,
      callback: function callback($$v) {
        _vm.$set(_vm.agendaForm, "titulo", $$v);
      },
      expression: "agendaForm.titulo"
    }
  })], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.tipoAgendaOptions
    },
    model: {
      value: _vm.agendaForm.tipo,
      callback: function callback($$v) {
        _vm.$set(_vm.agendaForm, "tipo", $$v);
      },
      expression: "agendaForm.tipo"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.agendaResponsavelLabel
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.agendaResponsavelOptions
    },
    model: {
      value: _vm.agendaForm.id_usuario,
      callback: function callback($$v) {
        _vm.$set(_vm.agendaForm, "id_usuario", $$v);
      },
      expression: "agendaForm.id_usuario"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data e horário"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local"
    },
    model: {
      value: _vm.agendaForm.data_inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.agendaForm, "data_inicio", $$v);
      },
      expression: "agendaForm.data_inicio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Duração em minutos"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "1440"
    },
    model: {
      value: _vm.agendaForm.duracao_minutos,
      callback: function callback($$v) {
        _vm.$set(_vm.agendaForm, "duracao_minutos", $$v);
      },
      expression: "agendaForm.duracao_minutos"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "crm-agenda-horarios"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-3"
  }, [_c('div', [_c('strong', [_vm._v("Horários disponíveis")]), _c('small', {
    staticClass: "crm-agenda-context"
  }, [_vm._v(" " + _vm._s(_vm.agendaHorariosContextoLabel) + " ")])]), _c('button', {
    staticClass: "btn btn-light-primary btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.loadingAgendaHorarios
    },
    on: {
      "click": _vm.buscarHorariosAgenda
    }
  }, [_vm._v(" Buscar horários ")])]), _vm.agendaHorariosErro ? _c('div', {
    staticClass: "alert alert-light-danger"
  }, [_vm._v(" " + _vm._s(_vm.agendaHorariosErro) + " ")]) : _vm.loadingAgendaHorarios ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Carregando horários... ")]) : _vm.agendaSlots.length === 0 ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Busque os horários antes de marcar. ")]) : _c('div', {
    staticClass: "crm-agenda-slots"
  }, _vm._l(_vm.agendaSlots, function (slot) {
    return _c('button', {
      key: slot.inicio,
      staticClass: "crm-agenda-slot",
      class: {
        selected: _vm.agendaSlotSelecionado(slot),
        unavailable: !slot.disponivel
      },
      attrs: {
        "type": "button",
        "aria-pressed": _vm.agendaSlotSelecionado(slot),
        "disabled": !slot.disponivel
      },
      on: {
        "click": function click($event) {
          return _vm.selecionarHorarioAgenda(slot);
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatTime(slot.inicio)))]), _c('small', [_vm._v(" " + _vm._s(slot.disponivel ? "Livre" : slot.motivo || "Ocupado") + " ")])]);
  }), 0)]), _c('b-form-group', {
    attrs: {
      "label": "Descrição"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3"
    },
    model: {
      value: _vm.agendaForm.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.agendaForm, "descricao", $$v);
      },
      expression: "agendaForm.descricao"
    }
  })], 1)], 1)]), _c('b-modal', {
    attrs: {
      "id": "crm-funil-nota-modal",
      "title": "Adicionar nota"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.adicionarNota.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Oportunidade"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.oportunidadeSelecionada.titulo,
      "disabled": ""
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Nota"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "4"
    },
    model: {
      value: _vm.notaForm.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.notaForm, "descricao", $$v);
      },
      expression: "notaForm.descricao"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };